import React, { FC } from 'react';
import { styled } from 'linaria/lib/react';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
import { Spacer } from '../Uikit/Spacer';
interface Props {
  phone: string;
  region?: string;
  icon?: React.ReactElement;
}
export const PhoneInfo: FC<Props> = ({
  phone,
  region = '',
  icon
}) => {
  const {
    isMobile
  } = useBreakpoint();
  const handleClick = value => {
    if (value === '@MTS_Oplata') {
      window.open('https://t.me/MTS_Oplata', '_blank');
    }
    if (!isMobile) return;
    if (value.includes('@') && !value.includes('@MTS_Oplata')) {
      window.location.href = `mailto:${value}`;
    } else {
      window.location.href = `tel:${value}`;
    }
  };
  return <PhoneWrapper>
      <div className="region">{region}</div>
      <Spacer space={4} spacemob={4} spacetablet={4} />
      <Wrapper phone={phone}>
        <WrapperIcon>{icon}</WrapperIcon>
        <div style={{
        cursor: 'inherit'
      }} className="phone" onClick={() => handleClick(phone)}>
          {phone}
        </div>
      </Wrapper>
    </PhoneWrapper>;
};
const PhoneWrapper = /*#__PURE__*/styled("div")({
  name: "PhoneWrapper",
  class: "pxbjl26"
});
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "wz2l545",
  vars: {
    "wz2l545-0": [({
      phone
    }) => phone === '@MTS_Oplata' ? 'pointer' : 'inherit']
  }
});
const WrapperIcon = /*#__PURE__*/styled("div")({
  name: "WrapperIcon",
  class: "wzia0sc"
});

require("./PhoneInfo.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./PhoneInfo.tsx");